document.addEventListener('rebuy.loaded', (event) => {

  //const smartCart = Rebuy.SmartCart;
  const subtotalMinReq = 12500;
  const labelOneTime = "Minimum Order of $125 on Frozen Seafood Required for Checkout.";
  const labelSubscription = "Subscription orders must contain $125 or more of subscription items.";
  const labelProgressRemaining = "🚚 You are {{remaining_amount}} away from FREE SHIPPING on frozen seafood items.";
  const labelProgressReached = "🎉 Congrats! You've unlocked <b>FREE SHIPPING!</b>";
  const ignoredTypes = ['Gift Card','Ebook','Canned Fish', 'Merch'];
  let activeLabel = labelOneTime;
  let checkoutBtn = null;
  let accordionToggle = null;
  let popUpTriggerBtn = null;

  const updateCheckoutBtn = (cart) => {

    let totalPrice = 0;
    let totalProducts = 0;
    let totalSubscriptions = 0;
    let hasSubscriptionItem = false;

    cart.items.forEach(lineItem =>{
      
      totalPrice = (lineItem.final_line_price * 1);

      if(ignoredTypes.includes(lineItem.product_type) == false){
        totalProducts += totalPrice;
      }

      if(lineItem.selling_plan_allocation != undefined){
        if(lineItem.selling_plan_allocation.selling_plan != undefined){
          totalSubscriptions += totalPrice;
          hasSubscriptionItem = true;
        }
      }

      //display final line 
      let priceSelectorString = '.rebuy-cart__flyout-items .product-'+lineItem.handle+' .rebuy-money span:nth-child(2)';
      let linePriceEl = document.querySelector(priceSelectorString);
      if(linePriceEl != null){
        linePriceEl.innerHTML = "$" + (lineItem.final_line_price/100).toFixed(2);
      }
      /*
      let comparePriceString = '.rebuy-cart__flyout-items .product-'+lineItem.handle+' .compare-at span:nth-child(2)';
      let lineComparePriceEl = document.querySelector(comparePriceString);
      if(lineComparePriceEl != null){
        let comarePrice = Number(lineComparePriceEl.innerHTML.replace("$", ''));

        let newComparePrice = comarePrice * lineItem.quantity;
        lineComparePriceEl.innerHTML = "$"+newComparePrice;
      }*/
      
    });

    findCheckoutBtn();

    if(checkoutBtn != null){
      if(hasSubscriptionItem == true && totalSubscriptions > 0 && totalSubscriptions < subtotalMinReq){
        activeLabel = labelSubscription;
        makeNewCheckoutBtn();
        checkoutBtn.style.display = "none";
        popUpTriggerBtn.style.display = "block";
      }else if(totalProducts > 0 && totalProducts < subtotalMinReq){
        activeLabel = labelOneTime;
        makeNewCheckoutBtn();
        checkoutBtn.style.display = "none";
        popUpTriggerBtn.style.display = "block";
      }else{
        makeNewCheckoutBtn();
        checkoutBtn.style.display = "block";
        popUpTriggerBtn.style.display = "none";
      }
    }

    //might not be needed with new progress bar
    //updateProgressForFrozenFood(totalProducts/100);
    
  }

  const findCheckoutBtn = () => {
    checkoutBtn = document.querySelector('.rebuy-button.rebuy-cart__checkout-button');
  }

  const makeNewCheckoutBtn = () => {
    if(popUpTriggerBtn == null){
      const newButton = document.createElement("button");
      newButton.className = "button";
      newButton.type = "rebuy-button";
      const message = document.createTextNode(activeLabel);
      newButton.appendChild(message);

      popUpTriggerBtn =  checkoutBtn.insertAdjacentElement("afterend", newButton);
      popUpTriggerBtn.addEventListener('click', (event) => {
        openPopup()
      });
    }
  }

  const accordionSetup = () => {
    accordionToggle = document.querySelector('[data-acc-toggle]');
    accordionToggle.addEventListener('click', (event) => {
      event.target.closest('.amb-accordion').classList.toggle("open");
    });
  }

   const updateProgressForFrozenFood = (frozenCartTotal) => {
    let progressBar = document.querySelector('.rebuy-cart__progress-bar-meter-fill');
    let progressMsgEl = document.querySelector('.rebuy-cart__progress-bar-prompt');
    let progressContainer = document.querySelector('.rebuy-cart__progress-bar-wrapper');
    
    let freeShippingTier = Rebuy?.SmartCart?.progressBar?.tiers.find(tier => tier.type === 'shipping');
    let tierMinimum = 125;
    if(freeShippingTier != undefined){
      tierMinimum = freeShippingTier.minimum;
    }

    if(progressContainer != null){
      if(frozenCartTotal >= tierMinimum){
        progressMsgEl.innerHTML = labelProgressReached;
        progressBar.style.width = '100%';
        console.log(frozenCartTotal,tierMinimum);
      }else{
        let remainingAmount = (tierMinimum - frozenCartTotal).toFixed(2);
        progressMsgEl.innerHTML = labelProgressRemaining.replace("{{remaining_amount}}", '$'+remainingAmount);
        progressBar.style.width = ((frozenCartTotal/tierMinimum)*100) + "%";
        console.log(frozenCartTotal,tierMinimum,remainingAmount);
      }

      if(frozenCartTotal >= 1){
        progressContainer.style.display = "block";
      }else{
        progressContainer.style.display = "none";
      }
    }else{
      console.log("progressContainer is null");
    }

  }

  const limitItemQuantities = () => {
    setTimeout(() => {
      const cartItems = Rebuy.SmartCart.items();
      let minQuantity = 1;

      cartItems.forEach(item => {

        if (item.product?.tags.includes("min-purchase-qty-2") ) {
          minQuantity = 2;
        }else{
          minQuantity = 1
        }

        if (item.quantity < minQuantity && item.line_price !== 0) {
          Rebuy.Cart.setItemQuantity(item, minQuantity)
        }
      })
    }, 300);
  }

  document.addEventListener('rebuy:cart.change', (event) => { 
    //console.log('rebuy:cart.change event');
    //need to delay because smart cart progress bar updates before this event fires.
    setTimeout(() => {
        updateCheckoutBtn(event.detail.cart.cart);  
      }, 10);

    limitItemQuantities();
    
  });

  document.addEventListener('rebuy:smartcart.show', (event) => {
    //console.log('rebuy:smartcart.show: smartcart');
    updateCheckoutBtn(event.detail.smartcart.cart);

    if(accordionToggle == null){
      accordionSetup();
    }
    
  });
   
});
